import React, { useRef, useState,useEffect, useContext } from 'react';
import styles from '../styles.module.css';
import SyntaxHighlighter from 'react-syntax-highlighter';
import {FaPlay,FaPause, FaArrowAltCircleLeft} from 'react-icons/fa';
import { beautifulCombinedBarLine, data as BarData, simpleNeonBars } from '../../BarCharts/BarChart/data';
import { data as HorizData } from '../../BarCharts/HorizBar/data';
import { AppContext } from '../../../AppContext';

const lineStyle={marginLeft:-20,fontSize:16,color:'gray'}
const modifiedBar=`import { BarChart } from "react-native-gifted-charts";
        
const App = () => {
    const stackData = [
        {
          stacks: [
            {value: 10, color: 'orange'},
            {value: 20, color: '#4ABFF4', marginBottom: 2},
          ],
          label: 'Jan',
        },
        {
          stacks: [
            {value: 10, color: '#4ABFF4'},
            {value: 11, color: 'orange', marginBottom: 2},
            {value: 15, color: '#28B2B3', marginBottom: 2},
          ],
          label: 'Mar',
        },
        {
          stacks: [
            {value: 14, color: 'orange'},
            {value: 18, color: '#4ABFF4', marginBottom: 2},
          ],
          label: 'Feb',
        },
        {
          stacks: [
            {value: 7, color: '#4ABFF4'},
            {value: 11, color: 'orange', marginBottom: 2},
            {value: 10, color: '#28B2B3', marginBottom: 2},
          ],
          label: 'Mar',
        },
      ];
    return(
        <View>
            <BarChart
            width={340}
            rotateLabel
            barWidth={12}
            spacing={40}
            noOfSections={4}
            barBorderRadius={6}
            stackData={stackData}
            />
        </View>
    );
};`;
const BarChartGallery=props=>{
    const appContext = useContext(AppContext);
    const{isMobile} = appContext;
    const [isPlaying,setIsplaying]=useState(false)
    const videoRef=useRef();
    const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.addEventListener('resize', updateWindowWidth);
    return () => {
      window.removeEventListener('resize', updateWindowWidth);
    }
  },[])
  
  const updateWindowWidth = () => {
    setWidth(window.innerWidth)
  }
    const onplayClick=()=>{
        if(isPlaying){
            videoRef.current.pause();
            setIsplaying(false)
        }
        else{
            videoRef.current.play();
            setIsplaying(true)
        }
    }
    const onVideoEnd=()=>{
        setIsplaying(false)
    }
    return(
        <div className={styles.container}>
            <FaArrowAltCircleLeft
            onClick={()=>{window.location.pathname="/gallery"}}
            style={{fontSize:30,position:'absolute',cursor:'pointer',top:isMobile?70:110}}/>
            <h2>
                Bar Chart Examples
                <a style={{marginLeft:20,fontSize:15}} target="_blank" href='https://github.com/Abhinandan-Kushwaha/react-native-gifted-charts/blob/master/docs/BarChart/BarChartProps.md' rel="noreferrer">
                    props table
                </a> 
            </h2>
            <div style={{marginLeft:10,marginBottom:100}}>
                <div className={styles.boxStyle}>
                    <img
                        src={BarData[5].imgSrc}
                        className={styles.barOutput}
                        alt=''/>

                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {BarData[5].code}
                    </SyntaxHighlighter>
                </div>

                <div className={styles.boxStyle}>
                    <img
                        src={BarData[6].imgSrc}
                        className={styles.barOutput}
                        alt=''/>

                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {BarData[6].code}
                    </SyntaxHighlighter>
                </div>
                <div className={styles.boxStyle}>
                    <video
                    ref={videoRef}
                    muted
                    autoPlay
                    onEnded={onVideoEnd}
                    src={require('../../../assets/animBar.mov')}/>

                    <p style={{fontSize:24}}>
                        {isPlaying?
                        <FaPause onClick={onplayClick}/>:
                        <FaPlay onClick={onplayClick}/>}
                    </p>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {BarData[7].code}
                    </SyntaxHighlighter>
                </div>
                <div className={styles.boxStyle}>
                    <img
                    src={require('../../../assets/hbarBlue.png')}
                    style={{height:400}}
                    alt=''/>
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                            {HorizData[0].code}
                    </SyntaxHighlighter>
                </div>
                <div className={styles.boxStyle}>
                    <img
                        src={require('../../../assets/roundStackBar.png')}
                        className={styles.barOutput}
                        alt=''/>
                    
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {modifiedBar}
                    </SyntaxHighlighter>
                </div>

                <div className={styles.boxStyle}>
                    <img
                        src={BarData[8].imgSrc}
                        className={styles.bigBarOutput}
                        alt=''/>
                    
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {BarData[8].code}
                    </SyntaxHighlighter>
                </div>

                <div className={styles.boxStyle}>
                    <img
                        src={'https://github.com/Abhinandan-Kushwaha/chart-images/blob/main/recordings/neon3D.gif?raw=true'}
                        className={styles.bigBarOutput}
                        alt=''/>
                    
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {simpleNeonBars}
                    </SyntaxHighlighter>
                </div>

                <div className={styles.boxStyle}>
                    <img
                        src={'https://github.com/Abhinandan-Kushwaha/chart-images/blob/main/screenshots/barLine.png?raw=true'}
                        style={{width: 380, borderRadius:20}}
                        alt=''/>
                    
                    <SyntaxHighlighter showLineNumbers lineNumberStyle={lineStyle} language="javascript">
                        {beautifulCombinedBarLine}
                    </SyntaxHighlighter>
                </div>
            </div>
        </div>
    );
}

export default BarChartGallery;